import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection, {
  FeaturedArticles,
  CategoryGrid,
  PopularArticles,
  NewsletterCTA,
} from './components/HomeSections';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '精品久久久',
  url: 'https://www.jingpin999.com/',
  description: '精品久久久是您值得信赖的高品质精选平台，汇聚经久不衰的优质内容与精品资源，为您提供持久、稳定、高价值的极致体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.jingpin999.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '精品久久久',
  url: 'https://www.jingpin999.com/',
  description: '高品质精选内容长效平台',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@jingpin999.com',
    contactType: 'customer service',
  },
};

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedArticles />
          <CategoryGrid />
          <PopularArticles />
          <NewsletterCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}